import { render, staticRenderFns } from "./FiltroDocs.vue?vue&type=template&id=f2959e42"
import script from "./FiltroDocs.vue?vue&type=script&lang=js"
export * from "./FiltroDocs.vue?vue&type=script&lang=js"
import style0 from "./FiltroDocs.vue?vue&type=style&index=0&id=f2959e42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports